import {
  ProfessionalsDownloadsDocumentsStore,
  ProfessionalsDownloadsDocumentsActions,
} from './types';

export const defaultState: ProfessionalsDownloadsDocumentsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  results: [],
  assetCategories: [],
};

const reducer = (
  state: ProfessionalsDownloadsDocumentsStore = defaultState,
  action: { type: ProfessionalsDownloadsDocumentsActions; payload?: any }
): ProfessionalsDownloadsDocumentsStore => {
  switch (action.type) {
    case ProfessionalsDownloadsDocumentsActions.FetchAssetsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case ProfessionalsDownloadsDocumentsActions.FetchAssetsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case ProfessionalsDownloadsDocumentsActions.FetchAssetsSuccess: {
      return {
        ...state,
        results: action.payload.assets,
        assetCategories: action.payload.assetCategories,
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
